<div>
  <div class="share-container d-flex align-items-center gap-2">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Share With</mat-label>
      <mat-select placeholder="Select User..."> </mat-select>
    </mat-form-field>
  </div>

  <div class="text-center">
    <small class="text-muted fst-italic">Coming Soon...</small>
  </div>
</div>
